import React, { useState } from 'react';
import LoadingComponent from '../commonComponents/LoadingComponent';
import { Dialogs } from '../constants/Dialogs';
import HeaderInGame from '../HeaderInGame';
import SurveyQuestion from './SurveyQuestion';
import { Feedback } from '../classes/Feedback';
import { KeyMoment } from '../classes/KeyMoment';
import { useNavigate } from "react-router-dom";

interface SurveyDialodInterface {
    dialog: Dialogs;
    setDialog: any;
    keyMoments: KeyMoment[];
    setKeyMoments: any;
    shouldGoHome: boolean;
    setShouldGoHome: any;
}

function SurveyDialog({dialog, setDialog, keyMoments, setKeyMoments, shouldGoHome, setShouldGoHome}: SurveyDialodInterface) {
    const navigate = useNavigate();
    const [contentRating, setContentRating] = useState(0);
    const [visualsRating, setVisualsRating] = useState(0);
    const [overallRating, setOverallRating] = useState(0);
    const [comment, setComment] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setComment(e.target.value);
    }

    const skip = async () => {
        if (shouldGoHome || keyMoments.length === 0) {
            navigate("/");
        } else {
            setDialog(Dialogs.keyMoments);
        }
    }

    const submit = async () => {
        setIsSubmitting(true);
        Feedback.addNewFeedback(contentRating, visualsRating, overallRating, comment.trim());
        setIsSubmitting(false);

        if (shouldGoHome || keyMoments.length === 0) {
            navigate("/");
        } else {
            setDialog(Dialogs.keyMoments);
        }
    }

    return (
        <div className="overallWrapper">
            <HeaderInGame/>
            <div className="surveyOuterWrapper">
                <div className="surveyInnerWrapper">
                    <div className="surveySkipButton" tabIndex={0} onClick={skip} onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            skip();
                        }
                    }}>Skip</div>
                    <h1 className="surveyTitle">Thanks for playing!</h1>
                    <div className="surveySubtitle">Please rate the game</div>
                    <SurveyQuestion question={"Content:"} rating={contentRating} setRating={setContentRating} />
                    <SurveyQuestion question={"Visuals:"} rating={visualsRating} setRating={setVisualsRating} />
                    <SurveyQuestion question={"Overall:"} rating={overallRating} setRating={setOverallRating} />
                    <input className="surveyCommentText"
                        type="text"
                        value={comment}
                        onChange={(e) => handleCommentChange(e)}
                        placeholder="Any comments about the game..."/>
                    <button className="surveySubmitButton" onClick={submit}>Submit</button>
                    {isSubmitting && <LoadingComponent/>}
                </div>
            </div>
        </div>
    );
};

export default SurveyDialog;